export default {
     "inc-gold-drop":{
          "ringIcons": [
               "_weapon_ring_14.png"
          ],
     },
     "poison-enemy":{
          "ringIcons": [
               "_weapon_ring_12.png"
          ],
     },
     "inc_critical_hit_ratio":{
          "ringIcons": [
               "_weapon_ring_11.png"
          ],
     },
     "inc_gold_enemy_drop":{
          "ringIcons": [
              "_weapon_ring_14.png"
          ],
     },
     "fill_hp":{
          "potionIcons": [
              "potion_img_02.png",
              "potion_img_06.png",
              "_weapon_potion_04.png"
          ],
     },
     "fill_mana":{
          "potionIcons": [
               "_weapon_potion_06.png",
               "potion_img_03.png"
          ],
     },
     "freeze-enemy":{
          "ringIcons": [
              "_weapon_ring_12.png"
          ],
     },
     "sheep-enemy":{
          "ringIcons": [
              "_weapon_ring_13.png"
          ],
     },
     "revive_hero":{
          "potionIcons": [
              "potion_img_05.png",
              "potion_img_04.png",
              "potion_img_01.png"
          ],
     },
     "revive_support":{
          "potionIcons": [
              "potion_img_08.png",
              "_weapon_potion_05.png",
              "_weapon_potion_08.png"
          ],
     },
     "inc_bag_slot":{
          "potionIcons": [
              "inventory_00.png",
          ],
     },
     "auto_tap":{
          "scrollIcons": [
              "_weapon_spell_03.png"
          ],
          "ringIcons": [
               "_weapon_ring_11.png",
          ]
     },
     "holding_tap":{
          "scrollIcons": [
              "_weapon_spell_04.png",
          ],
     },
}